<template>
  <div id="main-box" style="overflow: hidden;">
    <div class="page-content" :class="{bottom:list.length > 0}">
      <div class="table-box layui-body" style="left:0;">

        <div class="layui-form xblock">
          <button class="layui-btn xblock-row" v-on:click="SynchronizeOrders('同步订单')"><i class="fa fa-plus"></i>
            同步订单</button>
          <div class="layui-input-inline country_select xblock-row">
            <select v-model="searchDate" lay-verify="required" lay-filter="searchDate">
              <option value="0">一个月内</option>
              <option value="1">所有时间</option>
            </select>
          </div>
          <div class="layui-input-inline country_select xblock-row">
            <select v-model="current_status" lay-verify="required" lay-filter="status_selection">
              <option value="0">全部</option>
              <option :value="item.id" v-text="item.cn" v-for="(item,index) in status_list" v-bind:key="index"></option>
            </select>
          </div>
          <div class="layui-input-inline country_select xblock-row">
            <select v-model="received_status" lay-verify="required" lay-filter="received_status">
              <option value="0">全部</option>
              <option value="1">已签收</option>
            </select>
          </div>
          <div class="layui-input-inline country_select xblock-row" v-if="role == 10">
            <select v-model="warehouse" lay-verify="required" lay-filter="warehouse">
              <option value="0">全部</option>
              <option v-for="val in warehouseList" :value="val.id" v-text="val.name" v-if="val.state"></option>
            </select>
          </div>
          <div class="layui-input-inline xblock-row">
            <input type="text" class="layui-input" id="order_date" placeholder=" - " autocomplete="off" />
          </div>
          <div class="layui-input-inline xblock-row">
            <input type="text" name="username" placeholder="物流单号查询" v-on:keydown.13="get_order_list(true)"
              v-model="shipment_id" autocomplete="off" class="layui-input" />
          </div>
          <div class="layui-input-inline xblock-row">
            <input type="text" name="username" placeholder="订单编号查询" v-on:keydown.13="get_order_list(true)"
              v-model="order_id" autocomplete="off" class="layui-input" />
          </div>
          <div class="layui-input-inline xblock-row" style="width: 100px;">
            <input type="text" name="username" placeholder="UID查询" v-on:keydown.13="get_order_list(true)" v-model="uid"
              autocomplete="off" class="layui-input" />
          </div>
          <button class="layui-btn xblock-row" style="height: 36px;" lay-filter="sreach"
            v-on:click="get_order_list(true)"><i class="fa fa-search"></i></button>
          <div class="x-right xblock-row" style="line-height:38px;" v-text="'共有数据：'+count+ '条'"></div>

          <div class="clear-both"></div>
        </div>
        <div>
          <div class="table-box-row" :class="{'warn-order':item.iswarn}" v-for="(item,index) in list"
            v-bind:key="index">

            <div class="btn-arr">
              <button v-if="(item.ship_status == 2 || item.ship_status == 4)" class="layui-btn"
                v-on:click="ConfirmHint(5,item)">完成打包</button>
              <button v-if="item.ship_status == 2 && !item.tracking_no && item.order_status == 'READY_TO_SHIP'"
                v-on:click="ConfirmHint(3,item)" class="layui-btn layui-btn-normal">申请出货</button>
              <button v-if="item.tracking_no" v-on:click="PrintOrder(item)"
                class="layui-btn layui-btn-normal">打印面单</button>
              <button v-if="item.ship_status == 2" class="layui-btn" v-on:click="OrderBale('修改快递',item,2)">修改快递</button>
              <!-- <button v-on:click="ConfirmHint(4,item)" class="layui-btn layui-btn-danger">更新图片</button> -->
              <button class="layui-btn layui-btn-warm" v-on:click="ConfirmHint(2,item)">同步订单</button>
              <button v-if="item.ship_status != 3 && item.ship_status != 5" class="layui-btn layui-btn-danger"
                v-on:click="ConfirmHint(6,item)">关闭订单</button>
              <button v-if="item.ship_status == 4 || item.ship_status == 5" class="layui-btn"
                v-on:click="ConfirmHint(7,item)">恢复订单</button>
            </div>

            <table class="layui-table boxlist">
              <thead>
                <tr class="order-box">
                  <th>仓库</th>
                  <th>站点</th>
                  <th>用户ID</th>
                  <th>店铺名称</th>
                  <th style="min-width: 60px;">订单状态</th>
                  <th>出货天数</th>
                  <th>首公里绑定</th>
                  <th style="width: 140px;">订单编号</th>
                  <th>订单图片</th>
                  <th>商品数量</th>
                  <th>订单金额</th>
                  <th>买家</th>
                  <th>配送方式</th>
                  <th>日期</th>
                </tr>
              </thead>
              <tbody id="order_list">
                <tr class="order-box">
                  <td  v-on:click="item.isWarehouse = !item.isWarehouse" v-on:mouseleave="isWarehouseFun(index)">
                    <div v-if="role == 10" class="warehouseTd" >
                      <div style="width: 45px;" v-if="item.ship_status == 1">
                        <i>-</i>
                      </div>
                      <div v-else class="warehouseBox">
                        <i v-for="val in warehouseList" v-if="item.warehouse == val.id" v-text="val.name"></i>
                        <a class="warehouseSwitch">切换<i class="iconfont">&#xe6a7;</i></a>
                      </div>
                      <ul class="warehouseList" v-if="item.isWarehouse">
                        <li v-for="val in warehouseList" v-text="val.name" v-if="val.state" v-on:click="selectWarehouse(item.id,val)"></li>
                      </ul>
                    </div>
                    <div v-else style="width: 45px;">
                      <i v-for="val in warehouseList" v-if="item.warehouse == val.id" v-text="val.name"></i>
                    </div>
                  </td>
                  <td>
                    <i v-if="item.country == 'TW'">台湾</i>
                    <i v-else-if="item.country == 'PH'">菲律宾</i>
                    <i v-else-if="item.country == 'VN'">越南</i>
                    <i v-else-if="item.country == 'TH'">泰国</i>
                    <i v-else-if="item.country == 'ID'">印尼</i>
                    <i v-else-if="item.country == 'SG'">新加坡</i>
                    <i v-else-if="item.country == 'BR'">巴西</i>
                    <i v-else-if="item.country == 'MY'">马来西亚</i>
                    <i v-else-if="item.country == 'MX'">墨西哥</i>
                    <i v-else-if="item.country == 'CO'">哥伦比亚</i>
                    <i v-else-if="item.country == 'CL'">智利</i>
                    <i v-else-if="item.country == 'PL'">波兰</i>
                    <i v-else-if="item.country == 'ES'">西班牙</i>
                  </td>
                  <td v-text="item.uid"></td>
                  <td>
                    <i v-if="item.shop_name" v-text="item.shop_name"></i>
                    <i v-else v-text="item.shop_id"></i>
                  </td>
                  <td class="orangeTwoColor NoSelect">
                    <i v-if="item.order_status == 'UNPAID'" class="status-box status-box-red">待付款</i>
                    <i v-else-if="item.order_status == 'READY_TO_SHIP' && !item.tracking_no" class="status-box status-box-red">待处理</i>
                    <i v-else-if="(item.order_status == 'READY_TO_SHIP' || item.order_status == 'PROCESSED') && item.tracking_no" class="status-box status-box-red">待出货</i>
                    <i v-else-if="item.order_status == 'TO_RETURN'" class="status-box status-box-red">退货</i>
                    <i v-else-if="item.order_status == 'SHIPPED'" class="status-box status-box-red">运输中</i>
                    <i v-else-if="item.order_status == 'IN_CANCEL'" class="status-box status-box-red">订单取消申请</i>
                    <i v-else-if="item.order_status == 'CANCELLED'" class="status-box status-box-red">已取消</i>
                    <i v-else-if="item.order_status == 'TO_CONFIRM_RECEIVE'" class="status-box status-box-red">待完成</i>
                    <i v-else-if="item.order_status == 'COMPLETED'" class="status-box status-box-red">已完成</i>
                    <i v-else class="status-box status-box-red">未知</i>
                  </td>
                  <th>
                    <i v-text="item.order_datas.days_to_ship+'天'"></i>
                    <i style="color: #F65C5C;" v-if="item.order_datas.days_to_ship > 3">「预售」</i>
                  </th>
                  <td>
                    <i v-if="item.first_mile_tracking_number" v-text="item.first_mile_tracking_number"
                      v-on:click="logsearch(item.first_mile_tracking_number)" class="fkghint"></i>
                    <i v-else>无</i>
                  </td>
                  <td v-text="item.id"></td>
                  <td class="table_img">
                    <div :id="'qrCodeDiv'+index"></div>
                  </td>
                  <td v-text="item.order_datas.items && item.order_datas.items.length"></td>
                  <td>
                    <div v-if="item.order_datas.escrow_amount">
                      <i v-if="item.country == 'TW'" v-text="'NT'+item.order_datas.escrow_amount"></i>
                      <i v-else-if="item.country == 'MY'" v-text="'RM'+item.order_datas.escrow_amount"></i>
                      <i v-else-if="item.country == 'PH'" v-text="'₱'+item.order_datas.escrow_amount"></i>
                      <i v-else-if="item.country == 'VN'" v-text="'₫'+item.order_datas.escrow_amount"></i>
                      <i v-else-if="item.country == 'TH'" v-text="'฿'+item.order_datas.escrow_amount"></i>
                      <i v-else-if="item.country == 'ID'" v-text="'Rp'+item.order_datas.escrow_amount"></i>
                      <i v-else-if="item.country == 'SG'" v-text="'$'+item.order_datas.escrow_amount"></i>
                      <i v-else-if="item.country == 'BR'" v-text="'R$'+item.order_datas.escrow_amount"></i>
                      <i v-else-if="item.country == 'MX'" v-text="'MX$'+item.order_datas.escrow_amount"></i>
                      <i v-else-if="item.country == 'CO'" v-text="'COP'+item.order_datas.escrow_amount"></i>
                      <i v-else-if="item.country == 'CL'" v-text="'CLP'+item.order_datas.escrow_amount"></i>
                      <i v-else-if="item.country == 'PL'" v-text="'zł'+item.order_datas.escrow_amount"></i>
                      <i v-else-if="item.country == 'ES'" v-text="'€'+item.order_datas.escrow_amount"></i>
                      <i v-else-if="item.country == 'FR'" v-text="'€'+item.order_datas.escrow_amount"></i>
                    </div>
                  </td>
                  <th v-text="item.order_datas.buyer_username"></th>
                  <th v-text="item.order_datas.shipping_carrier"></th>
                  <td v-text="item.create_time"></td>
                </tr>

                <!-- 余额不足 -->
                <tr v-if="item.remark">
                  <td colspan="14" style="color:#F65C5C;">留言备注：[<i v-text="item.remark.type"></i>]<i
                      v-text="item.remark.remark"></i><a class="clear_message" v-on:click="ConfirmHint(8,item)">清除备注</a>
                  </td>
                </tr>

                <tr class="product_box" v-viewer>
                  <td colspan="14" class="product_box_tr" style="border:0;background-color: #FAFAFA;">
                    <div class="product_box">
                      <div class="table-header">
                        <table class="layui-table" style="" v-for="(val,ix) in item.order_datas.items">
                          <tbody class="images">
                            <tr>
                              <td colspan="14" class="product_box_tr"
                                style="border:0;padding:0 !important;margin-top:0;">
                                <div>
                                  <table class="layui-table" style="margin: 0;">
                                    <thead>
                                      <tr class="trth">
                                        <th>图片</th>
                                        <th>SKU</th>
                                        <th>名称</th>
                                        <th>规格</th>
                                        <th>货号</th>
                                        <th>数量</th>
                                        <th>价格</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr>
                                        <td class="table_img" :class="{'hintBack':!val.isTrue}"><img :src="val.img">
                                        </td>
                                        <td style="width:150px;word-break:break-all;" v-text="val.item_sku"></td>
                                        <td>
                                          <div style="max-width:300px;" v-text="val.item_name"></div>
                                        </td>
                                        <td v-text="val.variation_name"></td>
                                        <td v-text="val.variation_sku"></td>
                                        <td class="redColor" v-text="'x'+val.variation_quantity_purchased"></td>
                                        <td>
                                          <div>
                                            <i v-if="item.country == 'TW'"
                                              v-text="'NT'+val.variation_original_price"></i>
                                            <i v-else-if="item.country == 'PH'"
                                              v-text="'₱'+val.variation_original_price"></i>
                                            <i v-else-if="item.country == 'VN'"
                                              v-text="'₫'+val.variation_original_price"></i>
                                            <i v-else-if="item.country == 'TH'"
                                              v-text="'฿'+val.variation_original_price"></i>
                                            <i v-else-if="item.country == 'ID'"
                                              v-text="'Rp'+val.variation_original_price"></i>
                                            <i v-else-if="item.country == 'SG'"
                                              v-text="'$'+val.variation_original_price"></i>
                                            <i v-else-if="item.country == 'BR'"
                                              v-text="'R$'+val.variation_original_price"></i>
                                            <i v-else-if="item.country == 'MX'"
                                              v-text="'MX$'+val.variation_original_price"></i>
                                            <i v-else-if="item.country == 'CO'"
                                              v-text="'COP'+val.variation_original_price"></i>
                                            <i v-else-if="item.country == 'CL'"
                                              v-text="'CLP'+val.variation_original_price"></i>
                                            <i v-else-if="item.country == 'PL'"
                                              v-text="'zł'+val.variation_original_price"></i>
                                            <i v-else-if="item.country == 'ES'"
                                              v-text="'€'+val.variation_original_price"></i>
                                            <i v-else-if="item.country == 'FR'"
                                              v-text="'€'+val.variation_original_price"></i>
                                          </div>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </td>
                            </tr>

                            <tr v-if="val.shipment_number&&val.shipment_number.length > 0">
                              <td colspan="14" style="padding:0;border:0;">
                                <div>
                                  <table class="layui-table" style="margin: 0;">
                                    <tbody>
                                      <tr v-for="lognum in val.shipment_number" class="loglistborder">
                                        <td style="width: 280px;">
                                          <div class="loglist" v-if="lognum.number">
                                            <i class="ship_number"
                                              v-on:click="logsearch(lognum.number,item.uid,val)">快递单号：{{lognum.number}}</i>
                                            <i v-if="lognum.uid" class="redColor">〈已签收〉</i>
                                            <i v-else class="greenColor">〈未签收〉</i>
                                          </div>
                                          <div v-else>备注：无</div>
                                        </td>
                                        <td>
                                          <div v-if="lognum.is_verify_photo == 1 && lognum.is_handle == 1">
                                            <a class="redColor">〈已检测〉：</a>
                                            <a v-for="(v,vix) in lognum.verify_photo">
                                              <a class="execption_img" v-if="index == 0" v-text="'图片#'+(vix+1)"
                                                :href="v" target="view_window"></a>
                                              <a class="execption_img" v-else v-text="'，图片#'+(vix+1)" :href="v"
                                                target="view_window"></a>
                                            </a>
                                          </div>
                                          <div v-if="lognum.is_verify_photo == 1 && lognum.is_handle == 0">
                                            <a class="greenColor">〈待检测〉</a>
                                          </div>
                                        </td>
                                        <td>
                                          <div v-if="lognum.remark" style="color: red;">备注：{{lognum.remark}}</div>
                                          <div v-else>备注：无</div>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </td>
                            </tr>
                            <tr v-else>
                              <td colspan="14" style="padding:0;border:0;">
                                <div>
                                  <table class="layui-table" style="margin: 0;">
                                    <tbody>
                                      <tr class="loglistborder">
                                        <td style="width: 280px;">
                                          <div class="loglist">
                                            <i class="ship_number">快递单号：无</i>
                                          </div>
                                        </td>
                                        <td>
                                          <div>备注：无</div>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </td>
                            </tr>

                          </tbody>
                        </table>
                      </div>
                    </div>
                  </td>
                </tr>

                <!-- 底部内容 -->
                <tr>
                  <td class="table_footer_box" colspan="14">
                    <div>
                      <ul class="table_footer">
                        <li>
                          <p>打包状态：</p>
                          <p class="NoSelect">
                            <i v-if="item.ship_status == 2" class="status-box status-box-green">待打包</i>
                            <i v-else-if="item.ship_status == 3" class="status-box status-box-blue">已完成</i>
                            <i v-else-if="item.ship_status == 4" class="status-box status-box-red">异常</i>
                            <i v-else-if="item.ship_status == 5" class="status-box status-box-red">已关闭</i>
                          </p>
                        </li>
                        <li v-if="item.ship_status > 1 && item.bao_server && item.bao_server.etype">
                          <p>打包方式：</p>
                          <p class="NoSelect">
                            <i v-if="item.bao_server.etype.id == 51" class="status-box redColor"
                              v-text="item.bao_server.etype.name"></i>
                            <i v-else-if="item.bao_server.etype.id == 54" class="status-box redTwoColor"
                              v-text="item.bao_server.etype.name"></i>
                            <i v-else class="status-box greenColor" v-text="item.bao_server.etype.name"></i>
                          </p>
                        </li>
                        <li v-if="item.ship_status > 1 && item.bao_server && item.bao_server.gift">
                          <p>礼品：</p>
                          <p class="NoSelect">
                            <i v-if="item.bao_server.gift.name == '无'" v-text="item.bao_server.gift.name"></i>
                            <i v-else style="color: red;" v-text="item.bao_server.gift.name"></i>
                          </p>
                        </li>
                        <li v-if="item.ship_status > 1 && item.bao_server && item.bao_server.consumables">
                          <p>耗材：</p>
                          <p class="NoSelect">
                            <i v-if="item.bao_server.consumables.name == '默认耗材'"
                              v-text="item.bao_server.consumables.name"></i>
                            <i v-else style="color: red;" v-text="item.bao_server.consumables.name"></i>
                          </p>
                        </li>

                        <!-- 异常状态 -->
                        <li v-if="item.ship_status == 4">
                          <p>异常原因：</p>
                          <p class="status-error" v-text="item.execption_type"></p>
                        </li>
                        <li v-if="item.ship_status == 4">
                          <p>异常图片：</p>
                          <p class="status-error">
                            <a v-for="(img,index) in item.execption_img" class="execption_img">
                              <a class="execption_img" v-if="index == 0" v-text="'图片#'+(index+1)" :href="img"
                                target="view_window"></a>
                              <a class="execption_img" v-else v-text="'，图片#'+(index+1)" :href="img"
                                target="view_window"></a>
                            </a>
                          </p>
                        </li>
                        <li v-if="item.ship_status == 4">
                          <p>异常备注：</p>
                          <p class="status-error" v-text="item.execption_remark"
                            v-if="item.execption_remark && item.execption_remark != 'null'"></p>
                          <p class="status-error" v-else>无</p>
                        </li>
                        <!-- 异常状态 -->

                        <!-- 已完成 -->
                        <li v-if="item.ship_status == 3">
                          <p>包裹重量：</p>
                          <p class="status-error" v-text="item.weight+'g'"></p>
                        </li>
                        <li v-if="item.ship_status == 3">
                          <p>包裹费用：</p>
                          <p class="status-error" v-text="item.package_fee"></p>
                        </li>
                        <li v-if="item.ship_status == 3 || item.ship_status == 5">
                          <p>包裹图片：</p>
                          <p class="status-error">
                            <a v-for="(img,index) in item.package_img" class="execption_img">
                              <a class="execption_img" v-if="index == 0" v-text="'图片#'+(index+1)" :href="img"
                                target="view_window"></a>
                              <a class="execption_img" v-else v-text="'，图片#'+(index+1)" :href="img"
                                target="view_window"></a>
                            </a>
                          </p>
                        </li>
                        <li v-if="item.ship_status == 3 && item.package_at">
                          <p>打包时间：</p>
                          <p v-text="item.package_at"></p>
                        </li>
                        <!-- 已完成 -->


                        <li>
                          <p>留言备注：</p>
                          <p v-if="item.buyer_message" v-text="item.buyer_message" style="color: red;"></p>
                          <p v-else>无</p>
                        </li>
                        <li v-if="item.shipment_number && item.shipment_number.length > 0">
                          <p>快递单号：</p>
                          <p>
                            <a v-for="s in item.shipment_number" v-text="s" v-on:click="logsearch(s)"></a>
                          </p>
                        </li>

                        <li v-if="item.ship_status == 2">距离订单取消：<i class="status-error" v-text="item.countdown"></i>
                        </li>

                      </ul>
                    </div>
                  </td>
                </tr>

              </tbody>

            </table>
          </div>
        </div>

        <!-- transition -->
        <K-Transition :isLoding="isLoding" v-if="isLoding || list.length < 1" style="margin-top: 16px;"></K-Transition>
      </div>

    </div>

    <div class="loading-mask" v-if="isLoding"></div>

    <div class="page-box">
      <div id="pagebox" class="pagebox"></div>
    </div>

    <!--scroll to top-->
    <div class="scroll-top">
      <i class="fa fa-angle-up" aria-hidden="true"></i>
    </div>

    <!-- loading -->
    <K-Loading v-if="loading"></K-Loading>

    <!-- toast -->
    <K-Toast :Toast="Toast" @ChangeToast="ChangeToast"></K-Toast>

    <!-- 确认框 -->
    <K-Confirm :Confirm="Confirm" @ConfirmBackFun="ConfirmBackFun"></K-Confirm>

  </div>
</template>

<script>
  var self, form, layer, laydate, laypage, list_ix, this_ix, product, layerIndex;
  import axios from 'axios'
  import Loading from '@/components/common/Loading.vue'
  import Toast from '@/components/common/Toast.vue'
  import Transition from '@/components/common/Transition.vue'
  import Confirm from '@/components/common/Confirm.vue'
  import QRCode from 'qrcodejs2';
  export default {
    name: 'DeOrder',
    components: {
      'K-Loading': Loading,
      'K-Toast': Toast,
      'K-Transition': Transition,
      'K-Confirm': Confirm,
    },
    data() {
      return {
        isLoding: true,
        oid: null,
        uid: null,
        role: null,
        shop_id: null,
        layerIndex: null,
        loading: false,
        Toast: {
          state: false,
          type: 0,
          txt: null
        },
        Confirm: {
          state: false,
          txt: null
        },
        page: 1,
        count: 0,
        page_num: 20,
        order_id: null,
        shipment_id: null,
        module_type: 1,
        list: [],
        current_shop: 0,
        shop_list: [],
        current_status: 0,
        received_status: 0,
        searchDate: 0,
        status_list: [{
          id: 1,
          cn: '待打包'
        }, {
          id: 2,
          cn: '已完成'
        }, {
          id: 3,
          cn: '异常'
        }, {
          id: 4,
          cn: '已关闭'
        }],
        attach: [],
        warehouse: 0,
        warehouseList: warehouseList,
        logo: "https://cf.exshopee.cn/package/2022-05-08/16519987805bSZxjZUn3hZ0f26bcc0b1a9d401fea6a89124705f91.jpg"
      }
    },
    updated() {
      if (form) {
        form.render('select')
      }
    },
    watch: {
      $route: {
        handler(nv, ov) {
          self.current_status = nv.query.te;
          self.get_order_list(true)
        }
      },
      deep: true
    },
    mounted() {
      self = this;
      if (self.$route.query.te) {
        self.current_status = self.$route.query.te
      }
      self.role = localStorage.getItem("ExShopee_Role");

      scrollTop(); //监听滚动置顶
      layui.use(['form', 'layer', 'laydate', 'laypage'], function() {
        form = layui.form;
        layer = layui.layer;
        laydate = layui.laydate;
        laypage = layui.laypage;

        //时间控件
        laydate.render({
          elem: '#order_date',
          range: true
        });

        //状态选择
        form.on('select(status_selection)', function(data) {
          self.current_status = data.value;
          self.get_order_list(true)
          self.GoToPage("DeOrder?te=" + val);
        });

        //仓库选择
        form.on('select(warehouse)', function(data) {
          self.list = [];
          self.warehouse = data.value;
          self.get_order_list()
        });

        //日期选择
        form.on('select(searchDate)', function(data) {
          self.searchDate = data.value;
          self.get_order_list(true)
        });

        //状态选择
        form.on('select(received_status)', function(data) {
          self.received_status = data.value;
          self.get_order_list(true)
        });

        //店铺选择
        form.on('select(shops_selection)', function(data) {
          var val = $("select[name=shop").val();
          self.current_shop = val;
          self.get_order_list(true)
        });

        //待打包
        form.on('submit(bale)', function(data) {
          // var shipment_number = $("#shipment_number").val();
          // shipment_number = shipment_number.split(/[(\r\n)\r\n]+/);
          var buyer_message = $("#buyer_message").val();
          var lognumber = $("#lognumber").val();
          var remark = $("#remark").val();
          var logid = $("#log_select").val();
          var logtxt = $("#log_select option:selected").text();
          var remark = $("#remark").val();
          var consumables = $("#consumables").val();
          var gift = $("#gift").val();
          var etype = $('#etype input[name="etype"]:checked').val();
          var consumables_name = $("#consumables option:selected").text();
          var gift_name = $("#gift option:selected").text();
          var etype_name;
          if (etype == 50) {
            etype_name = "快速打包";
          } else if (etype == 54) {
            etype_name = "标准打包";
          } else {
            etype_name = "精细打包";
          }

          var logdatas = [];
          $(".product_main").each(function() {
            let id = $(this).attr("data-id");
            let pid = $(this).attr("data-pid");
            let isphoto = $(this).find(".isphoto").val();
            let log = $(this).find(".lognumber").val();
            let remark = $(this).find(".remark").val();
            logdatas.push({
              id: id,
              pid: pid,
              log: log,
              is_verify_photo: isphoto,
              remark: remark
            })
          })

          var x = 0;
          $(".remark").each(function() {
            logdatas[x].remark = $(this).val();
            x++
          })

          let param = new URLSearchParams()
          if (logdatas.length > 0) {
            param.append('shipment_number', JSON.stringify(logdatas))
          }
          param.append('buyer_message', buyer_message)
          param.append('id', self.oid)
          param.append('shop_id', self.shop_id)
          param.append('etype', JSON.stringify({
            id: etype,
            name: etype_name
          }))
          param.append('consumables', JSON.stringify({
            id: consumables,
            name: consumables_name
          }))
          param.append('gift', JSON.stringify({
            id: gift,
            name: gift_name
          }))

          //首公里
          var isFkg = $('#kilometer input[name="fkg"]:checked').val()
          if (isFkg == '是') {
            if (!logtxt) {
              self.ToastFun(1, "请选择正确的快递公司！"); //弹窗提醒
              return;
            }
            if (!lognumber) {
              self.ToastFun(1, "首公里快递单号不能为空！"); //弹窗提醒
              return;
            }
            param.append('express_sn', lognumber)
            param.append('logistics_channel_id', logid)
          }

          self.loading = true;
          axios({
            method: 'post',
            url: self.GetServerUrl() + "/bale_submit/",
            data: param,
            headers: {
              'token': localStorage.getItem("ExShopee_token")
            }
          }).then(function(response) {
            self.loading = false;

            //返回数据处理
            self.ReturnFuntion(self, response, function(datas) {
              self.get_order_list();
              self.modal_box_close();
              self.ToastFun(0, "操作成功！"); //弹窗提醒
            }, false, true);

          }).catch(function(error) {
            self.loading = false;
            self.ToastFun(2, error); //弹窗提醒
          })
          return false;
        });

        //添加快递
        form.on('submit(addlog)', function(data) {
          var ix = $('.Logboxlist').children().length;
          self.number = $(this).attr("data-number");
          var pid = $(this).attr("data-pid");
          var xhtml = "";
          xhtml +=
            '<div class="product_main" style="padding-bottom:20px !important;min-width:700px;" data-number="' +
            self.number + '" data-id="0" data-ix="' + ix + '" data-pid="' +
            pid + '">'

          xhtml += '<div class="layui-input-inline" style="margin-right:15px;margin-top:10px;">'
          xhtml +=
            '<label class="layui-form-label" style="padding:9px 0;text-align:left;width:70px">快递单号</label>'
          xhtml += '<div class="layui-input-inline">'
          xhtml += '<input type="text" data-id="0" data-pid="' + pid +
            '" autocomplete="off" class="layui-input lognumber">'
          xhtml += '</div>'
          xhtml += '</div>'

          xhtml += '<div class="layui-input-inline" style="margin-right:15px;margin-top:10px;">'
          xhtml +=
            '<label class="layui-form-label" style="padding:9px 0;text-align:left;width:70px">留言备注</label>'
          xhtml += '<div class="layui-input-inline">'
          xhtml += '<input type="text" autocomplete="off" class="layui-input remark">'
          xhtml += '</div>'
          xhtml += '</div>'
          xhtml +=
            '<button class="NoSelect layui-input-inline deleteLog NoSelect" type="button" style="background:#FFF;padding:9px 0;" lay-submit>库存选择</button>'
          xhtml +=
            '<button class="NoSelect layui-input-inline deleteLog NoSelect" type="button" lay-filter="deletelog" style="background:#FFF;padding:9px 0;padding-left:10px;" lay-submit>删除</button>'
          xhtml += '</div>'
          $(this).parent(".layui-input-item").prev(".Logboxlist").append(xhtml);

          form.render();
          return false;
        });

        //删除快递
        form.on('submit(deletelog)', function(data) {
          var _this = $(this);
          var id = $(this).parent().attr("data-id");
          if (parseInt(id)) {
            let param = new URLSearchParams()
            param.append('id', id)
            axios({
              method: 'post',
              url: self.GetServerUrl() + "/del_shipment/",
              data: param,
              headers: {
                'token': localStorage.getItem("ExShopee_token")
              }
            }).then(function(response) {

              //返回数据处理
              self.ReturnFuntion(self, response, function(datas) {
                _this.parent().remove();
              }, false, true);

            }).catch(function(error) {
              console.log(error);
              self.ToastFun(2, error); //弹窗提醒
            })
          } else {
            _this.parent().remove();
          }

          return false;
        });


        //首公里绑定
        form.on('submit(firstKg)', function(data) {
          var lognumber = $("#lognumber").val();
          var logid = $("#log_select").val();
          var logtxt = $("#log_select option:selected").text();
          var url = "/frist_mile/";
          let param = new URLSearchParams()

          if (self.module_type == 3) {
            param.append('id', self.oid)
            param.append('shop_id', self.shop_id)
          } else {
            url = "/frist_miles/"
            var orderlist = self.GetSelextOrder();
            param.append('datas', JSON.stringify(orderlist))
          }

          if (!logtxt) {
            self.ToastFun(1, "请选择正确的快递公司！"); //弹窗提醒
            return;
          }
          if (!lognumber) {
            self.ToastFun(1, "首公里快递单号不能为空！"); //弹窗提醒
            return;
          }
          param.append('express_sn', lognumber)
          param.append('logistics_channel_id', logid)

          self.loading = true;
          axios({
            method: 'post',
            url: self.GetServerUrl() + url,
            data: param,
            headers: {
              'token': localStorage.getItem("ExShopee_token")
            }
          }).then(function(response) {
            self.loading = false;

            //返回数据处理
            self.ReturnFuntion(self, response, function(datas) {
              self.isAll = false;
              self.get_order_list();
              self.modal_box_close();
              self.ToastFun(0, "操作完成！"); //弹窗提醒
            }, false, true);

          }).catch(function(error) {
            self.loading = false;
            self.ToastFun(2, error); //弹窗提醒
          })
          return false;
        });


        //模态框提交
        form.on('submit(example)', function(data) {
          if (self.module_type == 1) { //编辑订单

            var shipment_number = $("#shipment_number").val();
            shipment_number = shipment_number.split(/[(\r\n)\r\n]+/);
            var buyer_message = $("#buyer_message").val();

            self.loading = true;
            let param = new URLSearchParams()
            if (shipment_number.length > 0) {
              param.append('shipment_number', JSON.stringify(shipment_number.toString()))
            }
            param.append('buyer_message', buyer_message)
            param.append('id', self.oid)
            axios({
              method: 'post',
              url: self.GetServerUrl() + "/bale_submit/",
              data: param,
              headers: {
                'token': localStorage.getItem("ExShopee_token")
              }
            }).then(function(response) {
              self.loading = false;

              //返回数据处理
              self.ReturnFuntion(self, response, function(datas) {
                self.get_order_list();
                self.modal_box_close();
                self.ToastFun(0, "操作成功！"); //弹窗提醒
              }, false, true);

            }).catch(function(error) {
              self.loading = false;
              self.ToastFun(2, error); //弹窗提醒
            })
          } else { //同步订单
            var shop_id = $("#shop_list").val();
            var country = $("#shop_list").find("option:selected").attr("data-country");
            var t = $("#update_date").val();
            //日期不能为空
            if (!t) {
              return;
            }

            //获取的结束时间自动加一天
            var start_time, end_time;
            self.getDate(t, function(s, e) {
              start_time = s;
              end_time = e;
            })

            self.loading = true;
            let param = new URLSearchParams()
            param.append('country', country)
            param.append('shop_id', shop_id)
            param.append('start_time', start_time)
            param.append('end_time', end_time)
            axios({
              method: 'post',
              url: self.GetServerUrl() + "/synchronize_orders/",
              data: param,
              headers: {
                'token': localStorage.getItem("ExShopee_token")
              }
            }).then(function(response) {
              self.loading = false;

              //返回数据处理
              self.ReturnFuntion(self, response, function(datas) {
                self.get_order_list();
                self.modal_box_close();
                self.ToastFun(0, "订单导入成功！"); //弹窗提醒
              }, false, true);

            }).catch(function(error) {
              self.loading = false;
              console.log(error);
            })
          }
        });

        form.render('select');
        self.get_order_list(true); //加载订单
        self.GetAttachList();

      });

    },
    methods: {
      ToastFun(type, txt) {
        self.Toast.state = true;
        self.Toast.type = type;
        self.Toast.txt = txt;
      },
      ChangeToast() {
        self.Toast.state = false;
      },
      ConfirmBackFun(data) {
        self.Confirm.state = data.state;
        if (data.state) {
          var url;
          let param = new URLSearchParams()
          if (self.Confirm.style == 1) { //接单
            url = "/receive_order/"
            param.append('ids', self.oid)
          } else if (self.Confirm.style == 2) { //更新订单
            url = "/reload_order/"
            param.append('id', self.oid)
            param.append('shop_id', self.shop_id)
          } else if (self.Confirm.style == 3) { //申请出货
            url = "/get_tracking_number/"
            param.append('id', self.oid)
            param.append('shop_id', self.shop_id)
          } else if (self.Confirm.style == 4) { //申请出货
            url = "/reload_item_image/"
            param.append('id', self.oid)
          } else if (self.Confirm.style == 5) { //申请出货
            url = "/package_order/"
            param.append('ids', self.oid)
            param.append('weight', 50)
            param.append('imgs', self.logo)
          } else if (self.Confirm.style == 6) { //关闭订单
            url = "/close_order/"
            param.append('id', self.oid)
          } else if (self.Confirm.style == 7) { //恢复订单
            url = "/re_package_order/"
            param.append('id', self.oid)
            param.append('shop_id', self.shop_id)
          } else if (self.Confirm.style == 8) {
            url = "/remark_order/"
            param.append('ids', self.oid)
            param.append('remark', false)
          }

          self.Confirm.state = false;
          self.loading = true;
          axios({
            method: 'post',
            url: self.GetServerUrl() + url,
            data: param,
            headers: {
              'token': localStorage.getItem("ExShopee_token")
            }
          }).then(function(response) {

            //返回数据处理
            self.ReturnFuntion(self, response, function(datas) {
              self.ToastFun(0, "操作成功！"); //弹窗提醒
              self.get_order_list()
            }, false, true);

          }).catch(function(error) {
            self.loading = false;
            console.log(error);
          })

        }
      },
      get_order_list(s) {
        if (s) {
          self.list = []
          self.page = 1;
        }
        var t = $("#order_date").val();
        //获取的结束时间自动加一天
        var start_time, end_time;
        if (t) {
          self.getDate(t, function(s, e) {
            start_time = s;
            end_time = e;
          })
        }

        self.isLoding = true;
        let param = new URLSearchParams()
        param.append('te', self.current_status)
        param.append('num', self.page_num)
        param.append('can_package', self.received_status)
        param.append('searchDate', self.searchDate)

        if (self.uid) {
          param.append('uid', self.uid)
        }
        if (self.shipment_id) {
          param.append('shipment', self.shipment_id)
        }
        if(self.warehouse){
          param.append('warehouse', self.warehouse)
        }
        if (self.order_id) {
          param.append('id', self.order_id)
        }
        if (start_time) {
          param.append('start_time', start_time)
        }
        if (end_time) {
          param.append('end_time', end_time)
        }

        axios({
          method: 'post',
          url: self.GetServerUrl() + "/wx_order_list/?page=" + self.page,
          data: param,
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          }
        }).then(function(response) {
          self.isLoding = false;

          //返回数据处理
          self.ReturnFuntion(self, response, function(datas) {
            var dataList = datas.list;
            var shiplist = datas.shipment_list;
            var item_list = datas.item_list;
            for (var item in dataList) {
              dataList[item].isWarehouse = false; //是显示切换仓库
              var dataobj = JSON.parse(dataList[item].order_datas);
              var productobj = null;
              if (dataList[item].product_info) {
                productobj = JSON.parse(dataList[item].product_info);
              }
              dataList[item].product_info = productobj;

              //判断是否有图片写入
              let items = dataobj.items;
              if (dataobj.item_list) {
                items = dataobj.item_list
              }
              for (let i in items) {
                items[i].isTrue = true;
                items[i].shipment_number = []

                if (!items[i].image_info) {
                  if (dataList[item].product_info) {
                    let pobj = dataList[item].product_info; //获取图片信息，插入OBJ里面
                    if (pobj[i]) {
                      items[i].img = pobj[i].image; //图片写入
                    } else {
                      items[i].img = "../../../static/images/loading3.gif"; //图片写入
                    }
                  } else {
                    items[i].img = "../../../static/images/loading3.gif"; //图片写入
                  }

                  var itemid = items[i].item_id;
                  let str = items[i].variation_name;
                  let sku = str.split(",")[0];
                  let vid = items[i].variation_id;
                  if (!vid) {
                    vid = items[i].item_id;
                  }
                  if (item_list && item_list[itemid]) {
                    if (item_list[itemid][vid]) {
                      items[i].img = item_list[itemid][vid];
                    } else {
                      for (let z in item_list[itemid]) {
                        items[i].isTrue = false;
                        items[i].img = item_list[itemid][z];
                      }
                    }
                  }
                } else {
                  items[i].img = items[i].image_info.image_url; //图片
                  items[i].variation_quantity_purchased = items[i].model_quantity_purchased; //数量
                  items[i].variation_id = items[i].model_id; //变体id
                  items[i].variation_sku = items[i].model_sku; //变体货号
                  items[i].variation_name = items[i].model_name; //规格
                  items[i].variation_original_price = items[i].model_discounted_price; //价格
                  dataobj.items = items;
                }
              }
              dataList[item].order_datas = dataobj;

              //新版兼容
              if(dataobj.total_amount){
                dataobj.escrow_amount = dataobj.total_amount;
              }
              if(dataobj.create_time){
                dataList[item].create_time = self.timestampToTime(dataobj.create_time);
              }

              if(dataList[item].order_status != "READY_TO_SHIP" && dataList[item].order_status != "UNPAID" && dataList[item].order_status != "CANCELLED"){
                dataList[item].tracking_no = true;
              }
              if(dataobj.package_list && dataobj.package_list.length > 0){
                if(dataList[item].order_status == "PROCESSED"){
                  dataList[item].order_status = "READY_TO_SHIP";
                  dataList[item].tracking_no = dataobj.package_list[0].package_number;
                }
                if(dataobj.package_list[0].logistics_status == "LOGISTICS_PICKUP_DONE"){
                  dataList[item].tracking_no = dataobj.package_list[0].package_number;
                }
                dataobj.shipping_carrier = dataobj.package_list[0].shipping_carrier;
              }

              dataList[item].product_box_isshow = true; //初始化产品容器隐藏
              dataList[item].switch_icon = "-";

              //发货时间
              if (dataList[item].ship_status == 2) {
                var datearr = self.CountingDays(dataList[item].create_time, dataList[item]
                  .order_datas.create_time, dataList[
                    item].order_datas.days_to_ship, dataList[item].id);
                dataList[item].countdown = datearr[0]; //取消时间
                if (datearr[1] <= 2) {
                  dataList[item].iswarn = true;
                } else {
                  dataList[item].iswarn = false;
                }
              }

              //订单备注
              if (dataList[item].remark && dataList[item].remark != "") {
                dataList[item].remark = JSON.parse(dataList[item].remark);
              }

              //快递单号
              if (dataList[item].shipment_number) {
                dataList[item].shipment_number = dataList[item].shipment_number.split(',');
              }
              //打包图片
              if (dataList[item].package_img) {
                dataList[item].package_img = dataList[item].package_img.split(',');
              }
              //异常图片
              if (dataList[item].execption_img) {
                dataList[item].execption_img = dataList[item].execption_img.split(',');
              }

              //快递单号
              if (shiplist.length > 0) {
                for (let val in shiplist) {
                  if (dataList[item].id == shiplist[val].order_sn) {
                    let plist = dataList[item].order_datas.items;
                    for (let v in plist) {
                      if (plist[v].variation_id && plist[v].variation_id == shiplist[val].item_id) {
                        let lognum = null,
                          remark = null;
                        if (shiplist[val].shipment_number) {
                          lognum = shiplist[val].shipment_number;
                        }
                        if (shiplist[val].remark) {
                          remark = shiplist[val].remark;
                        }
                        if (shiplist[val].shipment_number || shiplist[val].remark) {
                          var imgs = [];
                          if (shiplist[val].verify_photo) {
                            imgs = JSON.parse(shiplist[val].verify_photo);
                          }
                          plist[v].shipment_number.push({
                            sid: shiplist[val].id,
                            uid: shiplist[val].scan_recevide_uid,
                            number: lognum,
                            remark: remark,
                            is_handle: shiplist[val].is_handle,
                            is_verify_photo: shiplist[val].is_verify_photo,
                            verify_photo: imgs
                          }); //快递单号和id写入
                        }
                      } else if (plist[v].item_id == shiplist[val].item_id) {
                        var imgs = [];
                        if (shiplist[val].verify_photo) {
                          imgs = JSON.parse(shiplist[val].verify_photo);
                        }
                        plist[v].shipment_number.push({
                          sid: shiplist[val].id,
                          uid: shiplist[val].scan_recevide_uid,
                          number: shiplist[val].shipment_number,
                          remark: shiplist[val].remark,
                          is_handle: shiplist[val].is_handle,
                          is_verify_photo: shiplist[val].is_verify_photo,
                          verify_photo: imgs
                        }); //快递单号和id写入
                      }
                    }
                  }
                }
              }
            }
            self.list = dataList;
            if (datas.page) {
              var pageDatas = datas.page;
              self.count = pageDatas.count; //页数
            }
            self.ShowPage(self, laypage, "get_order_list", 10); //分页
            $('.pagebox').show();

            self.$nextTick(() => {
              var datas = self.list,qrcode;
              for (let item in datas) {
                $("#qrCodeDiv" + item).html(""); //清空二维码容器
                new QRCode('qrCodeDiv' + item, {
                  text: datas[item].id,
                  width: 80,
                  height: 80,
                  colorDark: "#333", //二维码颜色
                  colorLight: "#FFF", //二维码背景色
                  correctLevel: QRCode.CorrectLevel.L //容错率，L/M/H
                });
              }
            })
          }, function(datas) {
            self.list = [];
            self.count = 0; //页数
            $('.pagebox').hide();

            //自动换页
            if (self.page > 1) {
              self.page -= 1;
              self.get_order_list();
            }

          });

        }).catch(function(error) {
          self.isLoding = false;
          console.log(error)
          self.ToastFun(2, error); //弹窗提醒
        })
      },
      CountingDays(md, mdc, sd, id) {
        var d = 6;
        if (sd > 3) {
          d += sd - 1;
        }
        if (self.getWeek(md) > 2 && self.getWeek(md) < 6) {
          d += 2;
        } else if (self.getWeek(md) == 6) {
          d += 1;
        }
        var cd = parseInt(new Date().getTime() / 1000); //当前日期

        md = self.dateChange(d, mdc)

        var timeDiff = md - cd;
        var day = parseInt(timeDiff / 86400);
        var hour = parseInt((timeDiff % 86400) / 3600);
        var minute = parseInt((timeDiff % 3600) / 60);
        var second = parseInt((timeDiff % 60));
        var countdown;

        if (day > 0) {
          countdown = day + "天" + hour + "时" + minute + "分" + second + "秒"
        } else if (hour > 0) {
          countdown = hour + "时" + minute + "分" + second + "秒"
        } else if (minute > 0) {
          countdown = minute + "分" + second + "秒"
        } else if (second > 0) {
          countdown = second + "秒"
        } else {
          countdown = "可同步订单状态已确定是否取消！"
        }

        return [countdown, day];
      },
      getWeek(date) {
        var week = new Date(date).getDay();
        if (!new Date(date).getDay()) {
          week = 7;
        }
        return week;
      },
      dateChange(num = 1, date = false) {
        date += (86400) * num; //修改后的时间戳
        return date;
      },
      SynchronizeOrders(title) {
        self.module_type = 2;
        self.modal_box_show(self, 'SynchronizeOrders', title);
      },
      OrderBale(title, item) {
        self.module_type = 1;
        self.oid = item.id;
        self.shop_id = item.shop_id;
        self.modal_box_show(self, 'OrderBale', title, item);
      },
      ConfirmHint(te, item) {
        self.oid = item.id;
        if (te == 1) {
          self.Confirm.txt = "是否确定领取订单？"
        } else if (te == 2) {
          self.shop_id = item.shop_id;
          self.Confirm.txt = "是否确定同步Shopee订单状态？"
        } else if (te == 3) {
          self.shop_id = item.shop_id;
          self.Confirm.txt = "是否确定出货？"
        } else if (te == 4) {
          self.shop_id = item.shop_id;
          self.Confirm.txt = "是否确认加载图片？"
        } else if (te == 5) {
          self.shop_id = item.shop_id;
          self.Confirm.txt = "是否确认完成订单？"
          // self.OrderCompleted();
        } else if (te == 6) {
          self.shop_id = item.shop_id;
          self.Confirm.txt = "是否确认关闭订单？"
        } else if (te == 7) {
          self.shop_id = item.shop_id;
          self.Confirm.txt = "是否确认恢复订单？"
        } else if (te == 8) {
          self.Confirm.txt = "是否确定清除备注？"
        }
        self.Confirm.style = te;
        self.Confirm.state = true;
      },
      logsearch(txt, uid, pro) {
        var arr = ["现货", "库存", "不管"];
        if (self.isInArray(arr, txt)) {
          localStorage.setItem("ExShopee_HistoryURL", "Stock");
          localStorage.setItem("ExShopee_NavSubIx", 1);
          if (pro.item_sku) {
            window.open(self.PromoteUrl() + "/#/StockRecord?uid=" + uid + "&sku=" + pro.item_sku);
          } else {
            var pid = pro.item_id;
            if (pro.variation_id) {
              pid = pro.variation_id;
            }
            window.open(self.PromoteUrl() + "/#/StockRecord?uid=" + uid + "&id=" + pid);
          }
        } else {
          window.open("https://www.baidu.com/s?ie=utf-8&f=8&rsv_bp=1&rsv_idx=1&tn=baidu&wd=" + txt);
        }
      },
      PrintOrder(item) {
        let param = new URLSearchParams()
        param.append('id', item.id)
        param.append('shop_id', item.shop_id)
        self.loading = true;
        axios({
          method: 'post',
          url: self.GetServerUrl() + "/print_order/",
          data: param,
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          }
        }).then(function(response) {

          //返回数据处理
          self.ReturnFuntion(self, response, function(datas) {

            //跳转打印
            // window.open(datas);
            var pdfs = [];
            pdfs.push(datas);
            localStorage.setItem("ExShopee_Pdfs", JSON.stringify(pdfs));
            window.open(self.PromoteUrl() + "/#/Print");

          }, false, true);

        }).catch(function(error) {
          self.loading = false;
          self.ToastFun(2, error); //弹窗提醒
        })
      },
      GetAttachList(item) {
        axios({
          method: 'post',
          url: self.GetServerUrl() + "/get_bao_server/",
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          }
        }).then(function(res) {
          var json = res.data;
          var datas = json.datas;
          if (json.code == 200) {
            var list = {};
            for (let i in datas) {
              if (!list.hasOwnProperty(datas[i].bao_type)) {
                list[datas[i].bao_type] = []
              }
              list[datas[i].bao_type].push(datas[i])
            }
            self.attach = list;
          } else if (json.code == 401) {
            self.GoToPage("/");
          }
        }).catch(function(error) {
          console.log(error);
        })
      },
      OrderCompleted() {
        var url;
        let param = new URLSearchParams()
        url = "/package_order/"
        param.append('ids', self.oid)
        param.append('weight', 50)
        param.append('imgs', self.logo)
        self.Confirm.state = false;
        self.loading = true;
        axios({
          method: 'post',
          url: self.GetServerUrl() + url,
          data: param,
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          }
        }).then(function(response) {

          //返回数据处理
          self.ReturnFuntion(self, response, function(datas) {
            self.ToastFun(0, "操作成功！"); //弹窗提醒
            self.get_order_list()
          }, false, true);

        }).catch(function(error) {
          self.loading = false;
          console.log(error);
        })
      },
      selectWarehouse (id,data){
        self.loading = true;
        let param = new URLSearchParams()
        param.append('id', id)
        param.append('warehouse', data.id)
        axios({
          method: 'post',
          url: self.GetServerUrl() + "/set_order_warehouse/",
          data: param,
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          }
        }).then(function(response) {
          self.loading = false;

          //返回数据处理
          self.ReturnFuntion(self, response, function(datas) {
            self.get_order_list();
          });

        }).catch(function(error) {
          self.loading = false;
          self.ToastFun(2, error); //弹窗提醒
        })
      },
      isWarehouseFun (ix) {
        self.list[ix].isWarehouse = false;
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .country_select {
    width: 120px;
  }

  .xblock {
    padding: 0 10px 0 5px;
  }

  .xblock-row {
    margin: 5px 0;
    margin-right: 5px;
  }

  .boxlist {
    margin-top: 15px;
    border: 1px solid #F3F3F3;
  }

  .btn-arr>button {
    margin-top: 0;
  }

  .switch {
    font-size: 20px;
    display: table;
    margin: 0 auto;
    cursor: pointer;
  }

  .table_footer_box {
    border: 0;
    padding: 0 !important;
  }

  .table_footer {
    overflow: hidden;
    padding: 5px 0 15px 0;
    border-top: 1px solid #F3F3F3;
  }

  .table_footer li {
    float: left;
    padding-right: 20px;
    padding-left: 20px;
    margin-top: 10px;
    border-right: 1px solid #E3E3E3;
  }

  .table_footer li:last-child {
    padding-right: 0;
    border-right: 0;
  }

  .table_footer li p {
    float: left;
    position: relative;
  }

  .table_footer a {
    color: #666;
    cursor: pointer;
    margin-right: 8px;
  }

  .table_footer a:hover {
    color: #01AAED;
  }

  .trth th {
    background-color: #fdfdfd;
  }

  .execption_img {
    margin-right: 0 !important;
  }

  .fkghint {
    cursor: pointer;
    display: inline-block;
    line-height: 18px;
    height: 18px;
    padding: 0 8px 0 8px;
    margin-bottom: 4px;
    white-space: nowrap;
    background-color: #f2fbf4;
    border: 1px solid #c5edd0;
    border-radius: 1px 10px 10px 1px;
    color: #5c7;
  }

  .addlog {
    cursor: pointer;
  }

  .inputbox {
    overflow: hidden;
    margin-bottom: 10px;
  }

  .inputbox a {
    display: block;
    float: left;
  }

  .inputbox a:first-child {
    max-width: 180px;
    width: calc(100% - 75px) !important;
  }

  .inputbox a input {
    width: calc(100% - 20px);
    padding: 0 10px;
    height: 30px;
    border: 1px solid #E3E3E3;
  }

  .inputbox a:hover {
    color: #333;
  }

  .inputbox a i:hover {
    color: #007DDB;
  }

  .inputbox a i:last-child {
    margin-left: 5px;
  }

  .inputbox a:last-child {
    width: 65px;
    line-height: 32px;
    margin-left: 10px;
  }

  .loglist {
    margin-top: 15px;
  }

  .loglist:first-child {
    margin-top: 0;
  }

  .loglistborder {
    border: 1px solid #e6e6e6;
  }

  .loglistborder td {
    padding: 15px;
    border: 0 !important;
  }

  .loglistborder:first-child {
    border-top: 0;
  }

  .table-box-row {
    overflow-x: auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/logistics/Order.vue